module.exports = __webpack_public_path__ + "img/p6.a4436651.png";